import { HttpClient } from "@angular/common/http";
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { getPriceIntegerDot, getPriceDecimal } from "../../shared/utils/utils";
import { ScriptService } from "../../shared/service/script.service";
import { SeoService } from "../../shared/service/seo.service";
import { Products } from "../product.model";
declare var $: any;
@Component({
  selector: "app-product-pdp",
  templateUrl: "./product-pdp.component.html",
  styleUrls: ["./product-pdp.component.scss"],
})
export class ProductPdpComponent implements OnInit {
  @Input() show: boolean = true;
  @Output() clearFilter = new EventEmitter();
  @ViewChild("prodItemQuantity") prodItemQuantity: ElementRef;
  escdown = false;
  // detect screen width
  public innerWidth: any;
  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.innerWidth = window.innerWidth;
  }
  @HostListener("document:keydown.escape", ["$event"])
  onKeydown(e) {
    this.escdown = true;
  }
  @HostListener("document:keyup.escape", ["$event"])
  onKeyup(e) {
    this.escdown = false;
  }
  getPriceIntegerDot: any;
  getPriceDecimal: any;
  pdpLoad: boolean = false;
  isOOS: boolean = false;
  singleProductData: any = null;
  pdpProductData = [];
  loadingSinglePro: any;
  availabilityInfo: any;
  activeSelect: any;
  prodItemval: any;
  checkoutText: any;
  pdpName: any;
  pdpTitle: any;
  retailers: any;
  tempData: any;
  locale: any;
  is404: any;
  isAsus: boolean = false;
  data: any;
  sub: any;
  sku: any;
  pdpEnv = "https://api.nvidia.partners/products/v1/search/networking-pdp";
  checkoutEnv =
    "https://api.store.nvidia.com/cart-management/v1/cart/networking";
  constructor(
    private router: Router,
    private http: HttpClient,
    private seoService: SeoService,
    private route: ActivatedRoute,
    private scripts: ScriptService,
    private translate: TranslateService
  ) {
    this.onResize(this);
    this.getPriceIntegerDot = getPriceIntegerDot;
    this.getPriceDecimal = getPriceDecimal;
  }

  ngOnInit(): void {
    //page=1&limit=9&locale=en-us
    this.loadingSinglePro = true;
    this.availabilityInfo;
    this.activeSelect = "false";
    this.prodItemval = 1;
    this.sub = this.route.params.subscribe((params) => {
      this.sku = params["sku"]; // (+) converts string 'id' to a number
      let pdpLocale;
      if (window.location.host.split(".")[0] != "store") {
        this.checkoutEnv =
          "https://stg-api.store.nvidia.com/cart-management/v1/cart/networking";
        if (
          window.location.host.split(".")[0].split("-")[0] == "dev" ||
          window.location.host.indexOf("localhost") > -1
        ) {
          this.pdpEnv =
            "https://stg-api.nvidia.partners/products/v1/search/networking-pdp";
        } else {
          this.pdpEnv =
            "https://" +
            window.location.host.split(".")[0].split("-")[0] +
            "-" +
            "api.nvidia.partners/products/v1/search/networking-pdp";
        }
      }
      try {
        this.pdpLoad = true;
        let searchParams = this.route.snapshot.params;
        this.locale = params["locale"];
        if (searchParams["locale"] == "en-us") {
          pdpLocale = "US";
        }
        this.http
          .get(this.pdpEnv, {
            params: { sku: searchParams["sku"], locale: pdpLocale },
            observe: "response",
          })
          .toPromise()
          .then((response) => {
            this.pdpLoad = false;
            if (response.body) {
              this.data = this.route.snapshot.data;
              this.tempData = response["body"];
              this.singleProductData = this.tempData;
              this.getSingleProductData(params);
            }
          });
      } catch (err) {
        this.is404 = true;
        this.scripts.load1();
      }
    });
  }
  bigCommCheckout(productDetails) {
    this.pdpLoad = true;
    console.log("productDetails===>", this.prodItemval);
    if (this.prodItemval > 0) {
      let atcData = {
        cart: {
          products: [
            {
              quantity: this.prodItemval,
              product_id: productDetails.externalID,
              // product_id: productDetails.productID,
            },
          ],
        },
      };
      this.http
        .post(this.checkoutEnv, atcData)
        .toPromise()
        .then((res: any) => {
          let cartResponse = res;
          window.location.href = cartResponse.viewCartUri;
        })
        .catch((error) => {
          console.log(error);
          this.pdpLoad = false;
        });
    } else {
      return false;
    }
  }
  pdpLDScriptData() {
    var pdpldScript = document.createElement("script");
    pdpldScript.type = "application/ld+json";
    let ldjson = {
      "@context": "https://schema.org/",
      "@type": "Product",
      name: this.singleProductData.displayName,
      image: this.singleProductData.imageURL,
      description: this.getMeta(""),
      mpn: this.singleProductData.productSKU,
      brand: {
        "@type": "Brand",
        name: "NVIDIA",
      },
      offers: {
        "@type": "Offer",
        price: this.singleProductData.productPrice,
        priceCurrency: "USD",
      },
    };
    pdpldScript.textContent = JSON.stringify(ldjson);
    document.getElementsByTagName("head")[0].appendChild(pdpldScript);
    let ldbcjson = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item:
            "https://store.nvidia.com/en-us/geforce/store/?page=1&limit=9&locale=" +
            this.locale,
        },
        {
          "@type": "ListItem",
          position: 2,
          name: this.singleProductData.category,
          item:
            "https://store.nvidia.com/" +
            this.locale +
            "/geforce/store/?page=1&limit=9&locale=" +
            this.locale +
            "&category=" +
            this.singleProductData.category,
        },
        {
          "@type": "ListItem",
          position: 3,
          name: this.singleProductData.gpu,
          item:
            "https://store.nvidia.com/" +
            this.locale +
            "/geforce/store/?page=1&limit=9&locale=" +
            this.locale +
            "&gpu=" +
            this.singleProductData.gpu,
        },
        {
          "@type": "ListItem",
          position: 4,
          name: this.singleProductData.displayName,
        },
      ],
    };
    var pdpbcldScript = document.createElement("script");
    pdpbcldScript.textContent = JSON.stringify(ldbcjson);
    pdpbcldScript.type = "application/ld+json";
    document.getElementsByTagName("head")[0].appendChild(pdpbcldScript);
  }
  formatNumber(n) {
    let formattedNumber = n.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });
    return formattedNumber;
  }
  getSingleProductData(searchParams) {
    try {
      if (this.singleProductData != null) {
        this.seoService.generateTags(
          this.locale,
          false,
          this.singleProductData.displayName
        );
        for (let [i, ret] of this.singleProductData["retailers"].entries()) {
          if (ret.retailerName.indexOf("nvidia.com") > -1) {
            if (ret.type == 80) {
              this.singleProductData.prdStatus = "out_of_stock";
            }
          }
        }
         let infoArr = [];
         for (let [i, info] of this.singleProductData[
           "productInfo"
         ].entries()) {
           console.log("info", info);

           if (info?.name == "gpu") {
             infoArr.push({ ...info, order: 1 });
           } else if (info?.name == "cpu_processor") {
             infoArr.push({ ...info, order: 3 });
           } else if (info?.name == "sys_memory_size") {
             infoArr.push({
               order: 4,
               name: info?.name,
               value:
                 info?.value +
                 " " +
                 this.singleProductData["productInfo"].filter(
                   (x) =>
                     x.name == "System Memory Type" ||
                     x.name == "sys_memory_type"
                 )?.[0]?.value,
             });
           } else if (
             info?.name == "HD Storage Size" ||
             info?.name == "hd_storage_size"
           ) {
             infoArr.push({
               order: 5,
               name: "storage",
               value:
                 info?.value +
                 " " +
                 this.singleProductData["productInfo"].filter(
                   (x) =>
                     x.name == "System Storage Type" ||
                     x.name == "hd_storage_type"
                 )?.[0]?.value,
             });
           } else if (
             info?.name == "screen_display_type" &&
             this.singleProductData.category == "LAPTOP"
           ) {
             infoArr.push({
               order: 2,
               name: "display_type",
               value:
                 this.singleProductData["productInfo"].filter(
                   (x) => x.name == "screen_size"
                 )?.[0]?.value +
                 " | " +
                 info?.value,
             });
           }
           //  else if (
           //    info?.name == "memory_size" &&
           //    this.singleProductData.category == "GPU"
           //  ) {
           //    infoArr.push({
           //      order: 2,
           //      name: "gpu_memory_size",
           //      value: info?.value,
           //    });
           //  }
           else if (
             info?.name == "gpu_boost_clock_speed" &&
             this.singleProductData.category == "GPU"
           ) {
             infoArr.push({
               order: 2,
               name: "gpu_boost_clock_speed",
               value: info?.value,
             });
           } else if (
             (info?.name == "gpu_memory_size" || info?.name == "memory_size") &&
             this.singleProductData.category == "GPU"
           ) {
             infoArr.push({
               order: 3,
               name: "gpu_memory",
               value:
                 info?.value +
                 " " +
                 this.singleProductData["productInfo"].filter(
                   (x) => x.name == "memory_type"
                 )?.[0]?.value,
             });
           } else if (
             info?.name == "cooling_system" &&
             this.singleProductData.category == "GPU"
           ) {
             infoArr.push({
               order: 4,
               name: "cooling_system",
               value: info?.value,
             });
           } else if (
             info?.name == "screen_size" &&
             this.singleProductData.category == "MONITOR"
           ) {
             infoArr.push({
               order: 1,
               name: "display_size",
               value: info?.value,
             });
           } else if (
             info?.name == "screen_display_type" &&
             this.singleProductData.category == "MONITOR"
           ) {
             infoArr.push({
               order: 1,
               name: "resolution",
               value: info?.value,
             });
           } else if (
             info?.name == "refresh_rate" &&
             this.singleProductData.category == "MONITOR" //for monitors
           ) {
             infoArr.push({
               order: 3,
               name: "refresh_rate",
               value: info?.value,
             });
           } else if (
             info?.name == "display_port_quantity" &&
             this.singleProductData.category == "MONITOR" //for monitors
           ) {
             infoArr.push({
               order: 4,
               name: "display_port_quantity",
               value: info?.value,
             });
           } else if (
             info?.name == "hdmi_ports" &&
             this.singleProductData.category == "MONITOR" //for monitors
           ) {
             infoArr.push({
               order: 5,
               name: "hdmi_ports",
               value: info?.value,
             });
           }
         }
         infoArr.sort((a, b) => a.order - b.order);
         this.singleProductData["productInfo"] = [...infoArr];
        this.singleProductData.salePrice = this.formatNumber(
          this.singleProductData.salePrice
        );
        this.singleProductData.minQty = 1;
        this.singleProductData.maxQty = 2;
        if (this.singleProductData.prdStatus == "out_of_stock") {
          this.isOOS = true;
        }
        this.prodItemval = this.singleProductData.minQty;
        this.retailers = this.singleProductData.retailers;
        this.pdpProductData = JSON.parse(
          window.localStorage.getItem("pdpProducts")
        );
        this.pdpLDScriptData();
        let productData = [];
        let products = new Products();
        if (
          this.singleProductData.externalID &&
          this.singleProductData.salePrice > 0
        ) {
          products.productID = this.singleProductData.externalID.toString();
          products.productName = this.singleProductData.displayName;
          $(".single-product-page").attr("aria-label", products.productName);
          if (products.productName.indexOf('asus') > -1) {
            this.isAsus = true;

          }
          products.productPrice = this.singleProductData.salePrice;
          products.minQuantity = this.singleProductData.minQty;
          products.maxQuantity =
            this.singleProductData.maxQty > 0
              ? this.singleProductData.maxQty
              : 1000000;
          products.parentId = 0;
          products.sku = this.singleProductData.productSKU;
          productData.push(products);
        }
      } else {
        this.is404 = true;
      }
    } catch (err) {
      this.is404 = true;
    }
  }
  loadBreadCrumbPage(pageId, bread) {
    if (bread === "category") {
      this.router.navigate([
        "/" +
        this.locale +
        `/geforce/store/?page=1&limit=9&locale=en-us&category=${pageId}`,
      ]);
    }
    if (bread === "gpu") {
      this.router.navigate([
        "/" +
        this.locale +
        `/geforce/store/?page=1&limit=9&locale=` +
        this.locale +
        `&gpu=${pageId}`,
      ]);
    }
    if (pageId === "/") {
      this.router.navigate(["/" + this.locale + "/geforce/store/"]);
    }
  }
  increaseQuantity(prodItemval) {
    if (
      this.singleProductData.maxQty === 0 ||
      this.prodItemval < this.singleProductData.maxQty
    ) {
      this.prodItemval = parseInt(prodItemval) + 1;
    }
  }

  decreaseQuantity(prodItemval) {
    if (prodItemval > this.singleProductData.minQty)
      this.prodItemval = prodItemval - 1;
  }
  validateQuantity(e) {
    let pattern = /^\+?(0|[1-9]\d*)$/;
    if (this.prodItemQuantity.nativeElement.value.match(pattern)) {
      if (
        Number(this.prodItemQuantity.nativeElement.value) >
        this.singleProductData.maxQty
      ) {
        e.stopPropagation();
        this.prodItemQuantity.nativeElement.value = this.prodItemval;
        return false;
      } else {
        this.prodItemval = this.prodItemQuantity.nativeElement.value;
      }
    } else {
      console.log("Matches=====>", false);
      e.stopPropagation();
      this.prodItemQuantity.nativeElement.value = this.prodItemval;
    }
  }
  getMeta(metaName) {
    const metas = document.getElementsByTagName("meta");
    for (let i = 0; i < metas.length; i++) {
      if (metas[i].getAttribute("name") === metaName) {
        return metas[i].getAttribute("content");
      }
    }
    return "";
  }
  validatePDPData(obj) {
    if (
      obj !== undefined &&
      this.pdpProductData.filter((item) => item.productID == obj.productID)
        .length == 0
    ) {
      this.pdpProductData.push(obj);
    }
  }
}